import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-philanthropy',
  templateUrl: './philanthropy.component.html',
  styleUrls: ['./philanthropy.component.css']
})
export class PhilanthropyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
     window.scrollTo(0, 0);
  }

}
